import {
  LaunchPinwheelFlowActionFragment,
  tag,
  TransactionRowFragment,
} from 'services/graphql/fragments/Fragments';
import { AnalyticsEventFragment } from 'services/graphql/fragments/HomeTilesContentFragment';
import { gql } from 'urql';

const PinwheelFlow = gql`
  fragment ButtonComponentFragment on ButtonComponentV2 {
    __typename
    id
    buttonText
    buttonStyle
    buttonOnClick {
      __typename
      ... on RouteNavigationAction {
        route
        analyticsEvent {
          ...AnalyticsEventFragment
        }
      }
      ...LaunchPinwheelFlowActionFragment
    }
  }

  query pinwheelFlowPage {
    pinwheelFlowPage {
      __typename
      ... on PinwheelFlowPageError {
        code
        errorTitle: title
        message
      }
      ... on DdPinwheelSetupPage {
        id
      }
      ... on DdManagementPage {
        id
        title
        subTitle
        statusTag {
          ...tag
        }
        inlineAlerts {
          id
          dismissId
          iconV2
          title
          body
          type
          bannerNavigation {
            __typename
            route
            analyticsEvent {
              ...AnalyticsEventFragment
            }
          }
          buttonTitle
          buttonAction {
            __typename
            route
            analyticsEvent {
              ...AnalyticsEventFragment
            }
          }
          alertName
        }
        stepChecklist {
          __typename
          id
          state
          icon
          descriptionText
          annotationText
        }
        actions {
          ...ButtonComponentFragment
        }
        byMonthsHistory {
          __typename
          icon {
            __typename
            id
            fallbackURL
            iconKey
            tint
            size
          }
          id
          title {
            __typename
            copy
            style {
              __typename
            }
            desktopStyle {
              __typename
            }
          }
          children {
            __typename
            ...TransactionRowFragment
          }
        }
        footerButton {
          ...ButtonComponentFragment
        }
        displayAnalytics {
          ...AnalyticsEventFragment
        }
      }
    }
  }
  ${AnalyticsEventFragment}
  ${TransactionRowFragment}
  ${LaunchPinwheelFlowActionFragment}

  ${tag}
`;

export default PinwheelFlow;
